<div>

	<schedule [target]="schedule"></schedule>

</div>